/**
 * The looping supporter-video montage on the video-first ask surface.
 *
 * A full Mux stream URL rather than a bare playback ID so it parses through the same
 * `parseSourceInfoFromUrl` every other petition video does, which derives the poster from it.
 *
 * Emptying it degrades the ask screen to the value-prop card with no video surface, rather than a
 * broken player. Annotated `string` rather than left as a literal to keep that path reachable:
 * narrowed to its literal value, `no-unnecessary-condition` proves the guard dead and deletes the
 * degradation with it.
 */
export const MONTAGE_VIDEO_URL: string = 'https://stream.mux.com/BbmfsF6G5DoPmF100MhkNnAkb4hLwJ02vDRivj45WPhWY.m3u8';
